import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import BoldTypography from "components/BoldTypography";
import GridBlock from "components/GridBlock";
import IconButton from "components/button/IconButton";
import WorkableIconButton from "components/button/WorkableIconButton";
import SimpleSelect from "components/SimpleSelect";
import {OfferChoiceDecision, OfferChoiceDecisionLabel} from "../constants/OfferChoiceDecision";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    decision: {
        width: 182,
    },
    positionName: {
        width: 250,
    }
}));

const EMPTY_SEARCH_OBJECT = {decision: "", positionName: ''}
const MAX_SEARCH_LENGTH = 100;

const decisionsList = [{label: Tr('procedure_status_0'), value: ""}, ...Object.keys(OfferChoiceDecision).map(key => ({
    label: OfferChoiceDecisionLabel(key),
    value: key
}))];

function OfferChoiceSearch(
    {
        searchInProgress,
        doSearch
    }) {

    const classes = useStyle();
    const [value, setValue] = useState({...EMPTY_SEARCH_OBJECT});
    const [submitState, setSubmitState] = useState(0);

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => value[k])
                .reduce((a, k) => ({...a, [k]: value[k]}), {});
            doSearch(valueFiltered);
        }
        // eslint-disable-next-line
    }, [submitState]);

    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleSubmit = () => {
        setSubmitState(x => x + 1)
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit()
        }
    }

    return (
        <>
            <BoldTypography>{Tr('search_box')}</BoldTypography>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
            >
                <SimpleSelect
                    className={classes.decision}
                    label={Tr('decision')}
                    items={decisionsList}
                    value={value.decision}
                    onChange={(e) => {
                        handleChange("decision", e);
                        handleSubmit();
                    }}
                />

                <TextField
                    className={classes.positionName}
                    label={Tr('search_part')}
                    onChange={e => handleChange('positionName', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.positionName}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={() => {
                        setValue(EMPTY_SEARCH_OBJECT);
                        handleSubmit()
                    }}/>
                </div>
            </GridBlock>
        </>
    )
}

OfferChoiceSearch.propTypes = {
    doSearch: PropTypes.func.isRequired,
    searchInProgress: PropTypes.bool
}


export default OfferChoiceSearch;